/**
 * Created by jonas on 2022-06-15.
 */
import {gsap} from "gsap";
import {KitchenDramaSushiMania} from "../../KitchenDramaSushiMania";
import {KitchenDramaSushiManiaGameAssets} from "../../KitchenDramaSushiManiaGameAssets";
import {TimelineSprite} from "@nolimitcity/slot-launcher/bin/animation/TimelineSprite";
import {KitchenDramaSushiManiaSound} from "../../sound/KitchenDramaSushiManiaSound";



export class CollectableView extends PIXI.Container{
    private prefix:string;
    private _sprite:PIXI.Sprite;
    public isCollected:boolean = false;
    private _collect:TimelineSprite;
    private _reset:TimelineSprite;

    private kamisabi = ["ka", "mi", "sabi"];
    private _win:TimelineSprite;
    private _winReset:TimelineSprite;
    private animations:TimelineSprite[];
    private _flySprite:PIXI.Sprite;

    private getOffset():{x:number, y:number} {
        const data = {x:0,y:0};
        if (this.prefix == "salmon"){
            data.x = 7;
            data.y = -13;
        }
        if (this.prefix == "rice"){
            data.x = 7;
            data.y = -13;
        }
        if (this.prefix == "soy"){
            data.x = 7;
            data.y = -14;
        }

        if (this.prefix == "mi"){
            data.x = 0;
            data.y = -4;
        }
        if (this.prefix == "sabi"){
            data.x = -8;
            data.y = -16;
        }


        return data;
    }

    constructor(prefix:string) {
        super();

        this.prefix = prefix;
        const offset = this.getOffset();

        this.animations = [];

        this._reset = new TimelineSprite(KitchenDramaSushiMania.assetLoader.getTextures(this.prefix + "_reset"));
        this._reset.anchor.set(0.5,0.5);
        this._reset.position.set(offset.x, offset.y);
        this.animations.push(this._reset);

        this._collect = new TimelineSprite(KitchenDramaSushiMania.assetLoader.getTextures(this.prefix + "_collect"));
        this._collect.anchor.set(0.5,0.5);
        this._collect.position.set(offset.x, offset.y);
        this.animations.push(this._collect);


        this.addChild(this._reset);
        this.addChild(this._collect);

        if (this.kamisabi.indexOf(this.prefix) >= 0){
            this._win = new TimelineSprite(KitchenDramaSushiMania.assetLoader.getTextures(this.prefix + "_win"));
            this._win.anchor.set(0.5,0.5);
            this._win.position.set(offset.x, offset.y);
            this.animations.push(this._win);

            this._winReset = new TimelineSprite(KitchenDramaSushiMania.assetLoader.getTextures(this.prefix + "_winReset"));
            this._winReset.anchor.set(0.5,0.5);
            this._winReset.position.set(offset.x, offset.y);
            this.animations.push(this._winReset);

            this._flySprite  = new PIXI.Sprite(KitchenDramaSushiMania.assetLoader.getTextures("kamisabi/"+ this.prefix + "-fly")[0]);
            this._flySprite.anchor.set(0.5,0.5);
            this._flySprite.visible = false;


            this.addChild(this._win);
            this.addChild(this._winReset);
            this.addChild(this._flySprite);
        }


        this.hideAllExcept(this._reset);
        this._reset.setFrame(this._reset.totalFrames);

    }

    public collect():gsap.core.Timeline {
        this.isCollected = true;
        const isKamisabi = this.kamisabi.indexOf(this.prefix) >= 0;
        const soundStart = isKamisabi ? 0 : 0.08;
        const animStart = isKamisabi ? 0.2 : 0;

        const tl = gsap.timeline();
        tl.add(()=>{
            this._collect.setFrame(0);
            this.hideAllExcept(this._collect);
        });
        tl.add(gsap.to(this, {duration:0.4}));


        tl.add(()=>{this.playCollectSound();}, soundStart);

        tl.add(()=>{this._collect.getAnimation()}, animStart);

        return tl;
    }

    public reset():gsap.core.Timeline {
        this.isCollected = false;
        const tl = gsap.timeline();

        tl.add(()=>{
            this.hideAllExcept(this._reset);
        })
        tl.add(this._reset.getAnimation());

        return tl;
    }

    public playWin() {
        const tl = gsap.timeline();
        tl.add(()=>{
            this.isCollected = false;
            this.hideAllExcept(this._win);
        })
        tl.add(this._win.getAnimation());

        const tlFly = gsap.timeline();
        tlFly.add(()=>{
            this._flySprite.position.set(0,0);
            this._flySprite.visible = true;
        });
        tlFly.add(gsap.to(this._flySprite.scale,  {duration:0.05, x : 0.6, y : 1.2, ease :"none"}));
        tl.add(() => KitchenDramaSushiMania.soundPlayer.playSound(KitchenDramaSushiManiaSound.KAMISABI_TAKEOFF));
        tlFly.add(gsap.to(this._flySprite, {duration: 0.15, y : - 700, ease : "none"}));
        tlFly.add(()=>{this._flySprite.visible = false;});

        tl.add(tlFly, ">-0.1");
        return tl;
    }

    public playWinReset() {
        const tl = gsap.timeline();
        tl.add(()=>{
            this.hideAllExcept(this._winReset);
        });
        tl.add(this._winReset.getAnimation());
        tl.add(()=>{
            this._reset.setFrame(this._reset.totalFrames);
            this.hideAllExcept(this._reset);
        });
        return tl;
    }

    private hideAllExcept(exception:TimelineSprite) {
        for (let anim of this.animations){
            if (anim == exception){
                anim.show();
            } else  {
                anim.hide();
            }
        }
    }


    private playCollectSound() {
        if (this.prefix == "salmon" || this.prefix == "rice" || this.prefix == "soy"){
            KitchenDramaSushiMania.soundPlayer.playSound(KitchenDramaSushiManiaSound.COLLECT_FREESPIN_SYMBOL);
        }
        else if (this.prefix == "ka"){
            KitchenDramaSushiMania.soundPlayer.playSound(KitchenDramaSushiManiaSound.COLLECT_KA);
        }
        else if (this.prefix == "mi"){
            KitchenDramaSushiMania.soundPlayer.playSound(KitchenDramaSushiManiaSound.COLLECT_MI);
        }
        else if (this.prefix == "sabi"){
            KitchenDramaSushiMania.soundPlayer.playSound(KitchenDramaSushiManiaSound.COLLECT_SABI);
        }
    }
}